<template>
	<div class="basis-page-cls" v-loading="loading">
		<section class="basis-cls_table">
			<div class="table">
				<table-pagination
					pagination
					:data="list"
					:column="column"
					:total="total"
					:page.sync="listQuery.pageNum"
					:limit.sync="listQuery.pageSize"
					@pagination="getList" />
			</div>
		</section>
		<el-drawer
			size="60%"
			:modal="false"
			:modal-append-to-body="false"
			:withHeader="false"
			:visible.sync="drawerKnowledge">
			<KnowInfo v-if="drawerKnowledge" sourceType="Review" :qaId="item.id" :item="item" @drawerKnowInfoClose="drawerKnowledge = false;" />
		</el-drawer>
	</div>
</template>

<script>
import KnowInfo from '../components/KnowInfo';
export default {
	components: {KnowInfo},
	data() {
		const formatDate = Vue.filter('formatDate');
		return {
			column: [
				{ label: '资源库', prop: 'resourceName' },
				{ 
					label: '标题', 
					minWidth: 180,
					render: (h, scope) => {
                        return <el-link onClick={() => this.handleView(scope.row)} type="primary">{scope.row.q}</el-link>
                    } 
				},
				{ label: '申请人', prop: 'createUserName' },
				{ label: '修改原因', prop: 'createRemark' },
				{ 
					label: '创建时间', 
					minWidth: 180,
					render: (h, scope) => {
						return <span>{formatDate(scope.row.createTime)}</span>
					} 
				},
				{ 
					label: '审核时间', 
					minWidth: 180,
					render: (h, scope) => {
						return <span>{formatDate(scope.row.lastUpdateTime)}</span>
					} 
				},
				{ 
					label: '结果', 
					width: 100,
					render: (h, scope) => {
                        return <div>
							<el-tag size="mini" type={scope.row.status == '1' ? '' : scope.row.status == '0' ? 'danger' : 'info'}>{scope.row.status == '1' ? '通过' : scope.row.status == '0' ? '不通过' : '已过期'}</el-tag>
						</div>
                    } 
				}
            ],
			listQuery: {
				pageNum: 1,
				pageSize: 10,
				statusIds: '1,0,7'
			},
			total: 0,
			list: [],
			loading: false,
			drawerKnowledge: false,
			item: '',
		}
	},
	async created() {
		await this.getList();
	},
	methods: {
		getList() {
			this.loading = true;
			this.listQuery.projectId = this.$store.getters.userInfo.brandIdentify;
			this.$api.apiPostKnowledgeQATaskList(this.listQuery).then(response => {
				if(response.errcode != 0) {
					this.loading = false;
					return;
				}
				this.list = response.data?.rows ? response.data?.rows : [];
				this.total = response.data?.total ? response.data?.total : 0;
				this.loading = false;
			});
		},
		handleView(row) {
			this.item = row;
			this.drawerKnowledge = true;
		}
	}
}
</script>